import * as React from 'react';

export interface NonProfitIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * NonProfitIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Non-Profit / 501(c)(3). Community building with pitched roof and large white heart on facade.
 */
const NonProfitIcon: React.FunctionComponent<NonProfitIconProps> = ({
  className,
  size = 40,
  title = 'Non-Profit (501(c)(3))',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <rect x="8" y="20" width="32" height="22" fill="#a8226e"/>
      <path d="M6 20 L24 10 L42 20 Z" fill="#671343"/>
      <path d="M24 35 Q16 28 16 22 Q16 18 19.5 18 Q22 18 24 21 Q26 18 28.5 18 Q32 18 32 22 Q32 28 24 35 Z" fill="#FFFFFF"/>
      <rect x="6" y="42" width="36" height="2" fill="#671343"/>
      <rect x="10" y="22" width="1.5" height="18" fill="#671343" opacity="0.4"/>
      <rect x="36.5" y="22" width="1.5" height="18" fill="#671343" opacity="0.4"/>
  </svg>
);

export default NonProfitIcon;
